import React, { useState, useEffect } from "react";
import log from "loglevel";

export default function QuizVdo({ quizFile, vdoFile }) {
    // ----- Log Level Configuration -----
    log.setLevel(process.env.REACT_APP_LOG_LEVEL || "info");

    // ----- Screen size handler -----
    const [modalSize, setModalSize] = useState({ width: "50vw", height: "50vh" });

    // Function to update modal size based on screen size
    const updateModalSize = () => {
        const width = Math.min(window.innerWidth * 0.8, 2000); // 80% of screen width, max 2000px
        const height = Math.min(window.innerHeight * 0.7, 1400); // 70% of screen height, max 1400px
        setModalSize({ width: `${width}px`, height: `${height}px` });
    };

    // Run once on mount & update on resize
    useEffect(() => {
        updateModalSize();
        window.addEventListener("resize", updateModalSize);
        return () => window.removeEventListener("resize", updateModalSize);
    }, []);
    // ----- Screen size handler -----


    log.info(`Quiz file: ${quizFile}, Quiz VDO: ${vdoFile}`);

    return (
        <div
            style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                width: modalSize.width,  // Custom width
                height: modalSize.height, // Custom height
            }}
        >
            <video width={modalSize.width} height={modalSize.height} controls>
                <source src={`/images/${quizFile}/${vdoFile}`} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};
